<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="../img/headerlogo.png" class="img" />
        </router-link>
      </div>
      <div class="center">
        <ul class="nav">
          <li class="nav__item">
            <router-link to="/" class="desc"> HOME </router-link>
          </li>
          <li class="nav__item">
            <router-link to="/products" class="desc"> SHOP </router-link>
          </li>
          <li class="nav__item">
            <div class="desc" @click="scrollToSection('#faq')">FAQ</div>
          </li>
          <li class="nav__item">
            <div class="desc" @click="scrollToSection('#how-to-get-started')">
              HOW IT WORKS
            </div>
          </li>
        </ul>
      </div>
      <div class="right">
        <div
          class="select-container"
          v-if="$parent.isAuth && curr"
          @click.stop="toggleDropdown"
        >
          <div class="select currency-select" :class="{ 'is-open': isDropdownOpen }">
            <span class="select-value">{{ curr }}</span>
            <img src="../img/chevron-down.svg" class="chevron" :class="{ 'rotated': isDropdownOpen }" />
          </div>
          <div class="dropdown-menu" v-if="isDropdownOpen">
            <div
              class="dropdown-item"
              v-for="item in currOptions"
              :key="item"
              @click="selectCurrency(item)"
              :class="{ 'active': item === curr }"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="balance" v-if="$parent.isAuth">
          <button class="button" @click="$parent.openTopUpModal">
            <img src="../img/corners/top-left-corner.svg" class="top-left" />
            <img src="../img/corners/top-right-corner.svg" class="top-right" />
            <img
              src="../img/corners/bottom-left-corner.svg"
              class="bottom-left"
            />
            <img
              src="../img/corners/bottom-right-corner.svg"
              class="bottom-right"
            />
            <div class="balance-text">
              <img src="../img/hederkooshel.svg" class="img" />
              <span class="desc amount"
                >{{ Math.floor(($parent.profileData.balance || 0) * 100) / 100 }}
              </span>

              <img src="../img/coin.svg" class="coin" />
              <img src="../img/plusheder.svg" class="plus-icon" />
              <img src="../img/plushederhover.svg" class="plus-icon-hover" />
            </div>
          </button>
        </div>
        <div class="cart" v-if="$parent.isAuth" @click="$parent.openCartModal">
          <img src="../img/hederkorzina.svg" class="img" />
          <div v-if="$parent.cartContents.length" class="desc indicator">
            {{ $parent.cartContents.length }}
          </div>
        </div>
        <router-link 
          to="/profile" 
          class="desc name-desc" 
          v-if="$parent.isAuth"
          :class="{ 'router-link-active': $route.path === '/profile' }"
        >
          <img 
            :src="$route.path === '/profile' ? require('../img/hederprofileactive.svg') : require('../img/hederprofile.svg')" 
            class="gg_profile" 
          />
        </router-link>
        <div
          class="button black button-login"
          v-if="!$parent.isAuth"
          @click="$parent.openAgeModal()"
        >
          <img src="../img/corners/top-left-corner.svg" class="top-left" />
          <img src="../img/corners/top-right-corner.svg" class="top-right" />
          <img
            src="../img/corners/bottom-left-corner.svg"
            class="bottom-left"
          />
          <img
            src="../img/corners/bottom-right-corner.svg"
            class="bottom-right"
          />
          <img src="../img/steam.svg" class="img" />
          LOGIN WITH STEAM
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: ["currency", "currencyCode", "currencyValue"],
  data: function () {
    return {
      curr: "",
      isDropdownOpen: false,
    };
  },
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ code }) => code);
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue;
    },
  },
  mounted() {
    this.curr = this.currencyCode;
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    selectCurrency(item) {
      this.curr = item;
      this.changeCurrency(item);
      localStorage.setItem("currency", item);
      this.closeDropdown();
    },
    selectCurr() {
      this.changeCurrency(this.curr);
      localStorage.setItem("currency", this.curr);
    },
    changeCurrency(item) {
      this.$emit("changeCurrency", item);
    },
    handleClickOutside(event) {
      const selectContainer = event.target.closest('.select-container');
      if (!selectContainer && this.isDropdownOpen) {
        this.closeDropdown();
      }
    },
    openSignInModal() {
      this.$emit("openSignInModal");
    },
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    decrease() {
      if (this.amount > 0) {
        this.amount = this.amount - 1;
      } else {
        this.amount = 0;
      }
    },
    increase() {
      this.amount = this.amount + 1;
    },
    toCheckout() {
      if (this.amount > 0) {
        this.topUpIsVisible = false;
        this.$emit("setAmount", this.amount);
        this.$router.push({ path: "cart", query: { amount: this.amount } });
      }
    },
  },
};
</script>
